module.exports = __webpack_public_path__ + "static/media/DSC_0310_HDR.49bf500b.jpg";